// getOptions call the backend API to get list of options
import { axiosInstance } from "./auth";

export const getOptions = async (sheetKey, dependent, optionId, type) => {
  // populate URL and append dependent if needed
  let url = `/optionlists/${sheetKey}`;
  if (!!dependent && !!optionId)
    url = `/optionlists/${sheetKey}?dependent=${dependent}&optionId=${optionId}`;
  else if (!!dependent) url = `/optionlists/${sheetKey}?dependent=${dependent}`;
  else if (!!optionId) url = `/optionlists/${sheetKey}?optionId=${optionId}`;
  else if (!!type) url = `/optionlists/${sheetKey}?type=${type}`;

  const response = await axiosInstance.get(url);
  if (
    !!response &&
    !!response.data &&
    !!response.data.data &&
    !!response.data.data.options
  )
    return response.data.data.options;
  return [];
};
